Core.PortalCheckoutShipping = {
    init: function() {
        Core.PortalCheckoutShipping.Cache = {
            $toggleRadioContent: $('.toggle-radiogroup-content[name="shippingCostOptions"]'),
            $btnContinueShipping: $('#btnContinueShipping'),
            $btnSaveAsDraft: $('#btnSaveAsDraft'),
            $btnRequestQuote: $('#btnRequestQuote')
        };

      // this.onStateChange();
      // this.updateSupplierSelect();
      this.handleSelectStore();
      this.handleStoreLocation();
      this.checkShippingMethod();
      this.handleBtnSubmit();
      this.handleRadio();

      Core.PortalCheckoutToggleRadioContent.handleRadioClick($('#divShipping .portal-radio__listbox-options-item'));
    },

    isPickup: function() {
        var pickup = $('input[name="shippingCostOptions"]:checked').data('pickup');

        if (pickup) {
            return pickup.toLowerCase() === 'true';
        }

        return false;
    },

    handleSelectStore: function() {
        $('#dropdownStoreLocation').on('change', function() {
            var $wrap = $(this).closest('.form-input');
            var $selObj =  $(this).data('kendoDropDownList');
            $('#hidStoreId').val(this.value);

            if(this.value) {
              $selObj.wrapper && $selObj.wrapper[0].classList.remove('error');
              $wrap.find('label.error').remove();
            } else {
              $selObj.wrapper && $selObj.wrapper[0].classList.add('error');
              if($wrap.find('label.error').length === 0) Core.AppendErrorLabel($wrap, "Please select store");
            }
        });
    },

    handleStoreLocation: function () {
        $('[data-StoreLocationDropDown]').on('change', function () {
            var $wrap = $(this).closest('.form-input');
            var $selObj = $(this).data('kendoDropDownList');
            $('#hidStoreStorePaidShippingId').val(this.value);

            if (this.value) {
                $wrap.find('label.error').remove();
            } else {
                if ($wrap.find('label.error').length === 0) Core.AppendErrorLabel($wrap, "Please select store");
            }
        });
    },

    onStateChange: function() {
      // get default value from selectedState (Home mod)
      var selectedState = $('.selectedState').val();
      $("#dropdownSupplierState").data("kendoDropDownList").value(selectedState);

      $("#dropdownSupplierState").on("change", function() {
        Core.PortalCheckoutShipping.updateSupplierSelect();
      });
    },

    updateSupplierSelect: function() {
      var installerList = Core.PortalCheckoutShipping.getSupplierList();

      $("[data-storelocationdropdown]").kendoDropDownList({
          dataSource: installerList,
          dataTextField: "Name",
          dataValueField: "Id"
      });

      $("[data-storelocationdropdown]").data("kendoDropDownList").value('');
    },

    // render options from selected State
    getSupplierList: function() {
      var selectedState = $("#dropdownSupplierState").val() || $('.selectedState').val(); // get default value from selectedState (Home mod)

      function isInstallerInState(installer) {
          return installer.State
              ? installer.State.toLowerCase() === selectedState?.toLowerCase()
              : false;
      }

      if (selectedState === '' || selectedState === 'all') {
          return [{Name: "Pick a supplier", "Id": ""}];
      }

      if (typeof window.StoreJson === 'undefined') {
          return [{Name: "Pick a supplier", "Id": ""}];
      }

      var installerListInState = window.StoreJson.filter(isInstallerInState);
      return [{Name: "Pick a supplier", "Id": ""}].concat(installerListInState);
    },

    handleRadio: function() {
        var _self = Core.PortalCheckoutShipping;

        _self.Cache.$toggleRadioContent.on('change', function() {
            var $el = $(this),
                name = $el.attr("name"),
                $group = $('[data-content="' + name + '"]'),
                $target = $group.find($el.attr("data-target"));

            Core.PortalCheckoutToggleRadioContent.resetRadio($el);

            $group.find('.portal-checkout__radiogroup-item.active').removeClass('active');
            $target.addClass('active');
            $("#shippingOption").val($el.data('id'));

            if ($el.data('price').toLowerCase() === "free") {
                Core.PortalCheckoutShipping.initMap();
                Core.PortalCheckoutShipping.initStoreDropdown();
            } else {
                Core.PortalCheckoutShipping.initStoreLocationDropdown();
            }
        });
    },

    validateShipping: function() {
        if (Core.PortalCheckoutShipping.isPickup()) {
            $('#hidStoreStorePaidShippingId').val('');
            var $store = $('#dropdownStoreLocation');
            var $selObj =  $store.data('kendoDropDownList');

            if(!$store.val()) {
                var $wrap = $store.closest('.form-input');

                if($wrap.find('label.error').length === 0) {
                  $selObj.wrapper && $selObj.wrapper[0].classList.add('error');
                  Core.AppendErrorLabel($wrap, "Please select store");
                }
                return false;
            } else {
              $selObj.wrapper && $selObj.wrapper[0].classList.remove('error');
            }

        } else {
            $('#hidStoreId').val('');
            var id = "store-" + $("#shippingOption").val();
                $store = $('#' + id);
            var $storeLength = $store.length;

            if ($storeLength==0) {
                return true;
            }
             $wrap = $store.closest('.form-input');
            if (!$store.val()) {
                if ($wrap.find('label.error').length === 0) {
                    Core.AppendErrorLabel($wrap, "Please select store");
                }
                else {
                    $wrap.find('label.error').show();
                }
                return false;
            } else {
                if ($wrap.find('label.error').length > 0) {
                    $wrap.find('label.error').remove();
                }
            }
        }

        return true;
    },

    checkShippingMethod: function() {
        var _self = Core.PortalCheckoutShipping;

        //if free ship is selected
        if(_self.isPickup()) {
            _self.initMap();
            _self.initStoreDropdown();

            var storeIdx = $('#dropdownStoreLocation option:selected').index();
            if(storeIdx) {
                Core.PortalPickupStores.Locator.showStoreInfo(storeIdx - 1);
                Core.PortalPickupStores.Locator.Map.setZoom(15);
            }
        }
    },

    initMap: function() {
        var $mapCanvas = $("#google-map-canvas");
        if ($mapCanvas.length && !$mapCanvas.hasClass('inited')) {
            Core.PortalPickupStores.Locator.init();
        }
    },

    initStoreDropdown: function() {
        var $dropdownStoreLocation = $('#dropdownStoreLocation');
        if ($dropdownStoreLocation.length && $dropdownStoreLocation.data('role') != "dropdownlist") {
            $dropdownStoreLocation.kendoDropDownList();
        }
    },

    initStoreLocationDropdown: function () {
        var $dropdownStoreLocation = $('[data-StoreLocationDropDown]');
        if ($dropdownStoreLocation.length && $dropdownStoreLocation.data('role') != "dropdownlist") {
            $dropdownStoreLocation.kendoDropDownList();
        }

        // var $dropdownState = $("#dropdownSupplierState");
        // if ($dropdownState.length && $dropdownState.data('role') != "dropdownlist") {
        //   $dropdownState.kendoDropDownList();
        // }
    },

    onClickSaveDraftButton: function() {
        var self = Core.PortalCheckoutShipping;
        var $btnSaveAsDraft = self.Cache.$btnSaveAsDraft;
        var $form = $('#frmSaveShipping');

        var isValidForm = function() {
            return self.validateShipping() && $form.valid();
        };

        var submitForm = function() {
            var action = $('#frmSaveShipping').attr('action').replace("SaveShipping", 'SaveAsDraft')
            $form.attr('action', action);
            $form.attr('data-ajax-success', "ajax_draf_OnSuccess");
            $form.attr('data-ajax-failue', "ajax_draf_OnFailure");
            $form.attr('data-ajax-complete', "ajax_draf_OnComplete");

            $form.trigger('submit');
        };

        var onClickBtn = function(e) {
            e.stopPropagation();
            self.showValidation();

            isValidForm()
                && Core.ModalSaveDraft.show().onSaveDraft(submitForm);
        };

        $btnSaveAsDraft.on('click', onClickBtn);
    },

    handleBtnSubmit: function() {
        var _self = Core.PortalCheckoutShipping;

        _self.Cache.$btnContinueShipping.on('click', function (e) {
            e.stopPropagation();
            _self.showValidation();

            var $form = $('#frmSaveShipping');
            if(_self.validateShipping() && $form.valid()) {
                //console.log('submit');
                $form.trigger('submit');
            }
        });

        _self.onClickSaveDraftButton();

        _self.Cache.$btnRequestQuote.on('click', function (e) {
            e.stopPropagation();
            _self.showValidation();

            var $form = $('#frmSaveShipping');
            if (_self.validateShipping() && $form.valid()) {
                //console.log('submit');
                var action = $('#frmSaveShipping').attr('action').replace("SaveShipping", 'RequestQuote')
                $form.attr('action', action);
                $form.attr('data-ajax-success', "ajax_draf_OnSuccess");
                $form.attr('data-ajax-failue', "ajax_draf_OnFailure");
                $form.attr('data-ajax-complete', "ajax_draf_OnComplete");

                $form.trigger('submit');
            }
        });
    },

    showValidation: function() {
        if (!$("[name=shippingCostOptions]").is(":checked")) {
            if (!$(".portal-checkout__listbox-options").find(".error").length) {
                $(".portal-checkout__listbox-options")
                    .append(
                        "<label for=\"shippingCostOptions\" class=\"error\">Please select shipping method</label>");
            }

            var $offset = $("[name=shippingCostOptions]").offset();
            var offset = $offset ? $offset.top : 0;

            $("html, body").animate({ scrollTop: offset - 30 }, 300);

            return;
        }

        if ($(".portal-checkout__listbox-options").find(".error").length)
            $(".portal-checkout__listbox-options .error").remove();
    }
};

Core.ModalSaveDraft = {
    show: function() {
        var _width = Core.IsMobile()
                        ? Core.Cache.$window.width()
                        : Core.Config.CartNotification.Width;

        var tmpl = `
        <div class="modal-save-draft">
            <div class="px-2 py-3 border-super-light-grey border-bottom-2 border-top-2">
                <table>
                    <tbody>
                        <tr>
                             <td>
                                Do you want to save the order as a draft?<br>
                                Once saved as a draft, the order can be retrieved and edited from your dashboard.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center pt-3 ">
                <button class="btn" data-btn="save">Save as draft</button>
                <button class="btn" data-btn="cancel">Cancel</button>
            </div>
        </div>
        `;

        $popup = $(tmpl).kendoWindow({
            width: _width,
            visible: false,
            modal: true,
            resizable: false,
            actions: ["Close"],
            pinned: true,
            draggable: false,
            appendTo: '#page-wrap',
            title: 'SAVE AS DRAFT',
            animation: false,
            close: function () {
                $('body').css('overflowY', '');
            }
        });

        $('body').css('overflowY', 'hidden');
        $popup.data("kendoWindow").center();
        $popup.data("kendoWindow").open();

        $(".k-overlay").on('click', function () {
            $popup.data("kendoWindow").close();
        });

        $(".k-window-action > span.k-i-close, .k-window [data-btn='cancel']").on('click', function (e) {
            e.preventDefault();
            $popup.data("kendoWindow").close();
        });

        $("[data-btn='save']").on('click', function() {
            Core.ModalSaveDraft.Cache
                && Core.ModalSaveDraft.Cache.onSaveDraft
                    && Core.ModalSaveDraft.Cache.onSaveDraft();

            $popup.data("kendoWindow").close();
        });

        return this;
    },

    onSaveDraft: function(callback) {
        Core.ModalSaveDraft.Cache = {
            onSaveDraft: callback
        };
    },
};
